export default {
  evaluation_list: {
    title: 'Lieferantenliste',
    // number_of_companies_answered: "",
    number_of_companies_displayed: '{start} bis {end} von {total} Unternehmen anzeigen',
    company_name: 'Name des Unternehmens',
    status: 'Status',
    questionnaire: 'Umfrage',
    plan: 'Plan',
    nothing: 'Keine Ergebnisse gefunden',
  },
  evidence_options: {
    all_plan: 'Alle Pläne',
    // plans_with_vouchers: "",
    // no_voucher_plan: "",
  },
  table_headers: {
    company_name: 'Name des Unternehmens',
    status: 'Status',
    esg_rating: 'ESG-Bewertung',
    esg_score: 'ESG-Punktzahl',
    environment: 'Umwelt',
    social: 'Soziales',
    governance: 'Governance',
    plan: 'Plan',
    questionnaire: 'Umfrage',
    answer_date: 'Datum der Antwort',
    answer_expires_date: 'Deadline',
  },
  plan_list: {
    // light: "",
    // starter: "",
    // basic: "",
    // standard: "",
    // enterprize: "",
  },
}
